import { startTransition } from 'react';
import { type ErrorInfo, hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import { configureUserTracking } from '#/rendering/client/utils/configureUserTracking';
import { renderingBootstrapClient } from '#/rendering/client/utils/renderingBootstrapClient';
import { log } from '#/utils/logging';

// Compatibility
window.global = window;

window.dataLayer = [];

// window.Idealist is set directly on the server's response HTML as a script
const { initUserEnvironment, config } = window.Idealist;

renderingBootstrapClient(config);

configureUserTracking({
  user: initUserEnvironment.user,
  environment: initUserEnvironment.environment,
  locale: config.idealist.locale,
});

startTransition(() => {
  hydrateRoot(document, <HydratedRouter />, {
    onRecoverableError: (error: unknown, errorInfo: ErrorInfo) => {
      window.Idealist.hydrationErrors = window.Idealist.hydrationErrors ?? [];
      window.Idealist.hydrationErrors.push({
        error,
        errorInfo,
      });
      if (config.idealist.onHydrationError === 'log-info') {
        log.info(error);
        log.info(errorInfo);
      } else if (config.idealist.onHydrationError === 'log-error') {
        // oxlint-disable-next-line no-console
        console.error(`Hydration error on ${window.location.href}`);
        log.info(errorInfo);
        log.error(error);
      } else if (config.idealist.onHydrationError === 'throw') {
        throw error;
      }
    },
  });
});

// ----------------------------------------
// Unregister service worker and cache
// ----------------------------------------

if ('serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      void registration.unregister();
    }
    return;
  });
}

if ('caches' in window) {
  void caches.keys().then((names) => {
    for (const name of names) {
      void caches.delete(name);
    }
    return;
  });
}
